<template>
  <div class="exchange-rates-page">
    <h1>Exchange Rates</h1>
    <form class="my-form-container" @submit.prevent="addExchangeRate">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="baseCurrency"><strong>Currency</strong></label>
            <v-select :options="currencies" v-model="baseCurrency" label="name" id="invoiceCurrency" :searchable="true" :filterable="true" :reduce="currency => currency.id"></v-select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="rate"><strong>Exchange Rate</strong></label>
            <input type="text" class="form-control" id="rate" placeholder="Please Enter Exchange Rate" v-model="rate" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="effectiveDate"><strong>Effective Date</strong></label>
            <input type="date" class="form-control" id="effectiveDate" placeholder="Please Enter Effective Date" v-model="effectiveDate" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <p><strong></strong></p>
            <button class="btn btn-primary" type="submit">Add Rate</button>
          </div>
        </div>
      </div>
    </form>
    <div v-for="(rates, date) in groupedExchangeRates" :key="date" class="rate-group">
      <h3>{{ date }}</h3>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Currency Code</th>
            <th scope="col">Currency Name</th>
            <th scope="col">Exchange Rate</th>
            <th scope="col">Effective Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rate, index) in rates" :key="rate.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ rate.base_currency.currency_code }}</td>
            <td>{{ rate.base_currency.full_name }}</td>
            <td>{{ rate.exchange_rate }}</td>
            <td>{{ formatDate(rate.effective_date) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
  
<script>
import * as SweetAlertConnector from '@/composables/SweetAlertConnector';
import * as Utilities from '@/composables/Utilities';
import * as FastAPI from '@/composables/FastAPI';
export default {
  name: 'ExchangeRatesPage',
  data() {
    return {
      exchangeRates: [],
      currencies: [],
      baseCurrency: '',
      rate: '',
      effectiveDate: this.getCurrentDate(),
      targetCurrencId: '',
    };
  },
  computed: {
    sortedExchangeRates() {
      return [...this.exchangeRates].sort((a, b) => new Date(b.effective_date) - new Date(a.effective_date));
    },
    groupedExchangeRates() {
      return this.sortedExchangeRates.reduce((groups, rate) => {
        // const date = rate.last_updated.split('T')[0]; // Assuming last_updated is an ISO string
        const date = this.formatDate(rate.effective_date);
        if (!groups[date]) {
          groups[date] = [];
        }
        groups[date].push(rate);
        return groups;
      }, {});
    }
  },
  methods: {
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed, so add 1
      const day = today.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getCurrencyName(code) {
      const currency = this.currencies.find(currency => currency.code === code);
      return currency ? currency.name : '';
    },
    modifyExchangeRates() {
      this.exchangeRates = this.exchangeRates.map(rate => {
        return {
          ...rate,
          base_currency_name: this.getCurrencyName(rate.base_currency),
        };
      });
    },
    formatDate(dateString) {
      return Utilities.formatDate(dateString);
    },
    async getExchangeRates() {
      await this.getCurrencies();
      const userDetails = await FastAPI.getCurrentUser();
      const targetCurrencyId = userDetails.mawi_business.country.main_currency_id
      console.log("Currencies", this.currencies);
      // const targetCurrencId = this.currencies.find(currency => currency.code === Configuration.getConfigurations().targetCurrency).id;
      console.log("Target Currency ID", targetCurrencyId);
      this.targetCurrencId = targetCurrencyId;
      this.exchangeRates = await FastAPI.getAllRateOfExchange(targetCurrencyId);
      console.log("Exchange Rates", this.exchangeRates);
      // this.modifyExchangeRates();
    },
    async addExchangeRate() {
      const currentDate = new Date(this.effectiveDate).toISOString();
      const rate = {
        base_currency_id: this.baseCurrency,
        target_currency_id: this.targetCurrencId,
        exchange_rate: this.rate,
        effective_date: currentDate,
        source: "source_system"
      };
      console.log("Rate", rate);
      SweetAlertConnector.showLoadingAlert('Adding Exchange Rate');
      FastAPI.createRateOfExchange(rate).then(() => {
        console.log("Exchange Rate Added Successfully");
        SweetAlertConnector.closeCurrentAlert();
        SweetAlertConnector.showSuccessAlert('Exchange Rate Added Successfully');
        this.getExchangeRates();
        this.baseCurrency = '';
        this.rate = '';
      }).catch((error) => {
        console.error("Failed to Add Exchange Rate", error);
        SweetAlertConnector.showErrorAlert('Failed to Add Exchange Rate', error);
      });
      this.getExchangeRates();
    },
    async getCurrencies(){
        try {
            this.currencies = await FastAPI.getCurrencies();
        }
        catch (error) {
            console.error("Error fetching currencies", error);
        }
    },
  },
  mounted() {
    this.getExchangeRates();
    // this.getCurrencies();
  }
}
</script>

<style scoped>
.exchange-rates-page {
  padding: 20px;
  text-align: center;
}
.form-group {
    margin-bottom: 20px; /* Adds space below each form group */
}
.form-check {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px; /* Adds space below each form group */
}
.form-check label {
    margin-right: 1rem;
}
.my-form-container {
    text-align: left;
}
</style>
